module.exports = __webpack_public_path__ + "img/202-Gris Argent Lisse.jpg";